export default () => ({
    errors:[],
    loading:false,
    buildPickability:[],
    pickWave:null,
    pickWaves:[],
    pickingLocations:[],
    buildInPickwave:[]
})